import type { PlatformInterface } from "./platform-interface";
import type { PlatformInfo } from "./platform-info";
import type { PlatformDeviceInfo, SystemInfoMemory } from "./platform-device-info";

export abstract class Platform implements PlatformInterface {
    abstract getInfo(): Promise<PlatformInfo>;
    abstract isSupported(): boolean;
    abstract getDeviceInfo(): Promise<PlatformDeviceInfo>;
    abstract getOSVersion(): string | null;
    abstract getMemoryInfo(): Promise<SystemInfoMemory | null>;

    isRunAllowed(): boolean {
        const appConfig = useAppConfig();

        if (!appConfig.featurePlatformCheckEnabled) {
            return true;
        }
        return this.isSupported();
    }

};